// Navbar.js
// Redux Container for the Navbar

// Imports
import { connect } from 'react-redux';
import Navbar from '../components/Navbar/';
import * as Action from '../actions/order';

// State Mapper
const mapStateToProps = state => ({
  products: state.product,
  prevOrders: state.order.archive,
});

// Action Mapper
const mapDispatchToProps = dispatch => ({
  closeOrder: (products) => dispatch(Action.closeOrder(products)),
  reopenOrder: () => dispatch(Action.reopenOrder()),
})

// Exports
export default connect(mapStateToProps, mapDispatchToProps)(Navbar);


// WEBPACK FOOTER //
// ./src/containers/Navbar.js